import fetch from './fetch'

export default {
  getGroups (payload) {
    let request = fetch({
      url: `/group`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },

  getGroup (payload) {
    let request = fetch({
      url: `/group/` + payload.id,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },

  getGroupNames (payload) {
    // const organizationId = payload.organization
    // delete payload.organization

    let request = fetch({
      url: `/view/location/`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  createGroup (payload) {
    let request = fetch({
      url: `/group`,
      method: 'post',
      data: payload
    })
    return request.call()
  },

  updateGroup (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/group/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },
  addGroupOrgnization (payload) {
    const { groupId } = payload
    let request = fetch({
      url: `/group/` + groupId + `/memberOrgs`,
      method: 'post',
      data: payload
    })
    return request.call()
  },

  findByName (payload) {
    let request = fetch({
      url: `/group/findByName?groupName=` + payload,
      method: 'get'
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/group.js